export default __webpack_public_path__ + "static/media/background_01@2x.ffb77120.jpg";